import type { OwaPalette } from 'owa-theme-shared';

export function getCopilotPaletteOverrides(_isDarkMode: boolean = false): OwaPalette {
    return {
        headerBrandText: '#FFFFFF',
        headerTextIcons: '#FFFFFF',
    };
}
